import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ApiClientService } from './common/api-client.service';
import { TenantEmailDisplaySetting } from 'models/tenantemailsetting';
import { manageAdminPermission, manageDepartment, manageJobTitle, SearchRolePermission, UsersRolePermissionsModel } from '../models/tenant.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TenantSettingService {

  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService,
    private http: HttpClient) { }

  getFirmTypeList() {
    return this.apiClient.get(`api/Tenant/getFirmTypeList`, null, null, true);
  }

  GetNPNBranchesByTenantId() {
    return this.apiClient.get(`api/Tenant/GetNPNBranchesByTenantId`, null, null, true);
  }

   getTenantFirmType() {
    return this.apiClient.get(`api/Tenant/getTenantFirmType`, null, null, true);
  }

  updateTenantFirmType(firmTypeId: number) {
    return this.apiClient.put(`api/Tenant/updateTenantFirmType/${firmTypeId}`, null, null, true);
  }

  getFirmOwnerList() {
    return this.apiClient.get(`api/Tenant/getFirmOwner`, null, null, true);
  }

  saveFirmOwner(obj: any) {
    return this.apiClient.post(`api/Tenant/firmOwner`, obj, null, true);
  }

  archiveFirmOwner(firmOwnerId: number) {
    return this.apiClient.put(`api/Tenant/archiveFirmOwner/${firmOwnerId}`, null, null, true);
  }

  getResponsibleProducerList() {
    return this.apiClient.get(`api/Tenant/getResponsibleProducer`, null, null, true);
  }

  saveResponsibleProducer(obj: any) {
    return this.apiClient.post(`api/Tenant/responsibleProducer`, obj, null, true);
  }

  archiveResponsibleProducer(responsibleProducerId: number) {
    return this.apiClient.put(`api/Tenant/archiveResponsibleProducer/${responsibleProducerId}`, null, null, true);
  }

  getTenantConfiguration(showLoading = true) {
    return this.apiClient.get(`api/Tenant/getTenantConfiguration`, null, null, showLoading);
  }

  updateTenantSendNotification(newValue: boolean, isEntity: boolean) {
    return this.apiClient.put(`api/Tenant/updateTenantSendNotification/${newValue}/${isEntity}`, null, null, true);
  }

  updateTenantFFMLookUp(newValue: boolean) {
    return this.apiClient.put(`api/Tenant/updateTenantFFMLookUp/${newValue}`, null, null, true);
  }

  getEmailDisplaySetting() {
    return this.apiClient.get(`api/Tenant/getEmailDisplaySetting`, null, null, true);
  }

  insertUpdateEmailDisplaySetting(obj: TenantEmailDisplaySetting) {
    return this.apiClient.post(`api/Tenant/insertUpdateEmailDisplaySetting`, obj, null, true);
  }

  getAllDepartmentList() {
    return this.apiClient.get('api/Tenant/getAllDepartmentList', null, null, true);
  }

  updateDepartment(obj: manageDepartment) {
    return this.apiClient.post(`api/Tenant/updateDepartment`, obj, null, true);
  }

  insertDepartment(obj: manageDepartment) {
    return this.apiClient.post(`api/Tenant/insertDepartment`, obj, null, true);
  }

  getAllJobTitleList() {
    return this.apiClient.get('api/Tenant/getAllJobTitleList', null, null, true);
  }

  updateJobTitle(obj: manageJobTitle) {
    return this.apiClient.post(`api/Tenant/updateJobTitle`, obj, null, true);
  }

  insertJobTitle(obj: manageJobTitle) {
    return this.apiClient.post(`api/Tenant/insertJobTitle`, obj, null, true);
  }

  usersRolePermissions(obj: UsersRolePermissionsModel) {
    return this.apiClient.post(`api/Tenant/UsersWithRolePermissions`, obj, null, true)
  }

  //getAdminPermissionList(roleId: number, userId?: number, isactive?: boolean) {
  //  return this.apiClient.get(`api/Tenant/rolePermissionList/${roleId}/${userId}/${isactive}`,null, null, true)
  //}

  getAdminPermissionList(obj: SearchRolePermission) {
    return this.apiClient.post(`api/Tenant/rolePermissionList`, obj, null, true);
  }

  insertUpdateRolePermission(obj: manageAdminPermission) {
    return this.apiClient.post(`api/Tenant/insertUpdateRolePermission`, obj, null, true)
  }

  public exportResponsibleProducerList() {
    return this.apiClient.export('api/Tenant/getResponsibleProducerList/Export', null, null, true);
  }

  public getUserRolePermissionLog(userId: number, roleId: number) {
    return this.apiClient.get(`api/Tenant/getuserRolePermissionLog/${userId}/${roleId}`, null, null, true);
  }

  getPermissionAccessTypes(): Observable<any> {
    return this.apiClient.get(`api/Contact/getPermissionAccessTypes`);
  }

  insertUpdateRolePermissionForAllContact(obj: manageAdminPermission) {
    return this.apiClient.post(`api/Tenant/insertUpdateRolePermissionForAllContact`, obj, null, true)
  }

  getProducerPaymentSettingsByTenant(isLoader:boolean=true){
    return this.apiClient.get(`api/Tenant/getProducerPaymentSettingsByTenant`,null,null,isLoader);
  }
  
  updateProducerPaymentSettingsByTenant(TenantPaymentInfo: any){
    return this.apiClient.put('api/Tenant/updateProducerPaymentSettingsByTenant', TenantPaymentInfo, null, true);
  }

  
  getAgenzeeFeatureListByPlanId(agenzeePlanId: number){
    return this.apiClient.get(`api/Tenant/getAgenzeeFeatureListByPlanId/${agenzeePlanId}`, null, null, false);  
  }

  createBulkImportActivityLog(bulkImportFile: File, description: string) {
    const formData = new FormData();

    formData.append('file', bulkImportFile);
    formData.append('description', description);
        
    return this.http.post(environment.baseUrl + `api/tenant/createBulkImportActivityLog`, formData, {
      reportProgress: true
    });
  }
}
